import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CreateBookingNoAdvanceFeeDto } from 'src/api/createBookingNoAdvanceFee/dto/CreateBookingNoAdvanceFee.dto';
import { postCreateBookingNoAdvanceFee } from 'src/api/createBookingNoAdvanceFee/requests';

export const usePostCreateBookingNoAdvanceFee = () =>
    useMutation<string, AxiosError, CreateBookingNoAdvanceFeeDto>({
        mutationFn: (verifyBookingData: CreateBookingNoAdvanceFeeDto) =>
            postCreateBookingNoAdvanceFee(verifyBookingData),
    });
